<template>
  <v-app id="inspire" class="fontLao">
    <div>
      <v-toolbar flat color="white">
        <v-toolbar-title>ຊື່ລູກຄ້າ/ຮ້ານ</v-toolbar-title>
          <v-divider
            class="mx-2"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="ຊອກຫາ"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <v-btn slot="activator" color="primary" dark class="mb-2">ເພີ່ມ</v-btn>
            <v-card>
              <v-card-title>
                <span class="headline fontLao">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap class="fontLao">
                    <v-flex xs12 sm6 md4 >
                      <v-text-field v-model="editedItem.name" label="ຊື່ລູກຄ້າ"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field v-model="editedItem.ad" label="ທີ່ຢູ່"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field v-model="editedItem.tel" label="ເບີໂທ"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer >
                <v-btn color="blue darken-1" flat @click.native="close" class="fontLao">ຍົກເລີກ</v-btn>
                <v-btn color="blue darken-1" flat @click.native="save" class="fontLao">ບັນທືກ</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      <v-data-table
      :headers="headers"
      :items="mydata"
      :search="search"
      :rows-per-page-items=[150,200,300,500]
      class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.ad }}</td>
          <td class="text-xs-center">{{ props.item.tel }}</td>
          <td class="text-xs-center px-0">
            <v-icon
            small
            class="mr-2"
            @click="branches(props.item)"
            >
              share
            </v-icon>
            <v-icon
            small
            class="mr-2"
            @click="gotopageCustomProductPrice(props.item)"
            >
              shopping_cart
            </v-icon>
            <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
            >
              edit
            </v-icon>
            <v-icon
            small
            @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </td>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">ກົດເລີ່ມໃໝ່</v-btn>
        </template>
      </v-data-table>
    </div>
  </v-app>
</template>
<script>
import db from '@/firebase/init'
  export default {
    name:'customer',
    data: () => ({
      dialog: false,
      search: '',
      headers: [
        { text: 'ຊື່ລູກຄ້າ', align: 'left', sortable: true, value: 'name' },
        { text: 'ທີ່ຢູ່', value: 'ad', align: 'center' },
        { text: 'ເບີໂທ', value: 'tel', align: 'center' },
        { text: 'ການເຄື່ອນໄຫວ', value: 'name', sortable: false, align: 'center' }
      ],
      mydata: [],
      editedIndex: -1,
      customerIndex: -1,
      editedItem: {
        name: '',
        ad: '',
        tel:'',
        stt:1
      },
      defaultItem: {
        name: '',
        ad: '',
        tel:'',
        stt:1
      }
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'ເພີ່ມລູກຄ້າ' : 'ແກ້ໄຂລູກຄ້າ'
      }
    },
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    created () {
     this.initialize()
        // this.fix()
      // this.initialize()
    },
    methods: {
      initialize () {
      let tdata=[];
      let ref = db.collection('customer').where("stt","==",1).get().then(snapshot => {
        snapshot.forEach(doc => {
          // console.log(doc.id, '=>', doc.data());
          let tmpdata =doc.data();
          tmpdata.id =doc.id;
          tdata.push(tmpdata);
        });
        this.mydata=tdata;
      })
      .catch(err => {
        console.log('Error getting documents', err);
      });
    },fix(){
       console.log('start')
      db.collection('stock').get()
        .then(snapshot => {
                  snapshot.forEach( async doc => {
                    let tmpdata =doc.data();
                    tmpdata.id =doc.id;   
                    var mysock =doc.data();
                    var pro = doc.data().product
                 await pro.get().then( async doc => {
                      if (doc.exists) {

                      mysock.cid1 =doc.data().cid
                        ///tmpdata.product = doc.data().name

                    //   console.log(doc.data().cid);
                    await  mysock.categorieref.get().then( async doc => {
                        if (doc.exists) {
                          //  console.log('Doneeee')
                          console.log('>>>id',tmpdata.id,'cid real' ,mysock.cid1,'cid2',doc.id)

                          if (mysock.cid1!==doc.id)
                      {
                          console.log('>>>id',tmpdata.id,'cid real' ,mysock.cid1,'cid2',doc.id)
                          
                 //   await  db.collection('stock').doc(tmpdata.id).update({categorieref:db.collection('categories').doc(mysock.cid1)})
                        }
                      
                        }
                      
                      })

                      }
                      })

                  // return;
                  })
        })
    },
    editItem (item) {
      this.editedIndex = this.mydata.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      console.log(item)
    },
    deleteItem (item) {
      const index = this.mydata.indexOf(item)
      if ( confirm('Are you sure you want to delete this item ('+item.name+' )?')) {
        // Delete it!
        db.collection('customer').doc(item.id).update({stt:0})//,{merge: true}
        this.mydata.splice(index, 1)
      }
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {
        // Object.assign(this.mydata[this.editedIndex], this.editedItem)
        let id=this.editedItem.id;
        delete this.editedItem.id;
        let ref = db.collection('customer').doc(id).update(this.editedItem)//,{merge: true}
      } else {
        let ref = db.collection('customer').add(this.editedItem)
      }
      this.initialize()
      this.close()
    },
    gotopageCustomProductPrice (item) {
      //console.log(item.id)
      this.$router.push({ name: 'CustomProductPrice', params: { id:item.id  }})
    },
    branches (item) {
      //console.log(item.id)
      this.$router.push({ name: 'Branches', params: { id:item.id  }})
    }
  }
}
</script>

<style>
  .fontLao{
    font-family: phetsarath ot !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Customer.vue